import { Meter } from '../types'

/**
 * Returns true if pairing id is bounded to [1, 250] (both inclusive)
 * @param pairingId The pairing id in the input
 */
export const isWithinBounds = (pairingId: number): boolean => {
  return 1 <= pairingId && pairingId <= 250
}

/**
 * Check if the same id exists in a different meter or the htc320h IO device.
 */
export const getIsDuplicatePairingId = (
  currentMeterId: string,
  pairingId: number,
  meters: Meter[],
  htc320hIoPairingId: string | undefined
): boolean => {
  if (getDuplicatesHtc320Io(pairingId, htc320hIoPairingId)) return true

  return getDuplicatesOtherMeter(currentMeterId, pairingId, meters)
}

const getDuplicatesHtc320Io = (pairingId: number, htc320hIoPairingId: string | undefined): boolean => {
  return pairingId === Number(htc320hIoPairingId)
}

const getDuplicatesOtherMeter = (currentMeterId: string, pairingId: number, meters: Meter[]): boolean => {
  const metersWithoutCurrent = meters.filter(meter => meter.id !== currentMeterId)
  return metersWithoutCurrent.some(meter => Number(meter.pairingId) === pairingId)
}
